"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminUpdateDto = void 0;
const admin_1 = require("../admin");
const misc_1 = require("../../../misc");
class AdminUpdateDto extends (0, misc_1.generateUpdateDto)(admin_1.Admin, ['name', 'privileges']) {
}
exports.AdminUpdateDto = AdminUpdateDto;
